export default {"src":"/_next/static/media/BlossmLogoSmallWhite.d07152c5.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};